/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export const InvoiceFileNameEnum = {
    DisbursementStatementPdf: 'DisbursementStatement.pdf',
    EarningsStatementCsv: 'EarningsStatement.csv',
    EarningsStatementPdf: 'EarningsStatement.pdf',
    InvoicePdf: 'Invoice.pdf',
};
